import { cn } from "@/libs/utils";

export const CloserIcon = ({ className }: { className?: string }) => (
  <svg
    className={cn("size-10", className)}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#DDE1E6" />
    <path
      d="M20 20.7025L16.618 24.0847C16.5257 24.1769 16.4096 24.2241 16.2698 24.2263C16.1302 24.2285 16.012 24.1812 15.9153 24.0847C15.8188 23.988 15.7705 23.8709 15.7705 23.7333C15.7705 23.5958 15.8188 23.4787 15.9153 23.382L19.2975 20L15.9153 16.618C15.8231 16.5257 15.7759 16.4096 15.7737 16.2698C15.7716 16.1302 15.8188 16.012 15.9153 15.9153C16.012 15.8188 16.1291 15.7705 16.2667 15.7705C16.4042 15.7705 16.5213 15.8188 16.618 15.9153L20 19.2975L23.382 15.9153C23.4743 15.8231 23.5904 15.7759 23.7302 15.7737C23.8698 15.7716 23.988 15.8188 24.0847 15.9153C24.1812 16.012 24.2295 16.1291 24.2295 16.2667C24.2295 16.4042 24.1812 16.5213 24.0847 16.618L20.7025 20L24.0847 23.382C24.1769 23.4743 24.2241 23.5904 24.2263 23.7302C24.2285 23.8698 24.1812 23.988 24.0847 24.0847C23.988 24.1812 23.8709 24.2295 23.7333 24.2295C23.5958 24.2295 23.4787 24.1812 23.382 24.0847L20 20.7025Z"
      fill="#21272A"
    />
  </svg>
);
